import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  spacing?: 'sm' | 'md' | 'lg' | 'xl';
  background?: 'default' | 'subtle' | 'glass';
}
export function Section({
  children,
  className = '',
  spacing = 'lg',
  background = 'default'
}: SectionProps) {
  const spacings = {
    sm: 'py-8 md:py-12',
    md: 'py-12 md:py-16',
    lg: 'py-16 md:py-24',
    xl: 'py-20 md:py-32'
  };
  const backgrounds = {
    default: '',
    subtle: 'bg-slate-900/30',
    glass: 'glass backdrop-blur-modern'
  };
  return <section className={`${spacings[spacing]} ${backgrounds[background]} ${className}`} data-id="element-657">
      {children}
    </section>;
}